export default class SmsService {

}
